/**
 * Sort function for items with an order property
 * @param a First item to compare
 * @param b Second item to compare
 * @returns Negative if a comes before b, positive if b comes before a, 0 if equal
 */
export function sortByOrder<T extends { order?: number }>(a: T, b: T): number {
	return (a.order ?? 0) - (b.order ?? 0);
}
